import { Injectable, Signal } from "@angular/core";
import { patchState, signalStore, withState } from "@ngrx/signals";
import { Store } from "../models/store/store.model";
import { StoreService } from "../services/store.services";
import { UserStore } from "./user.store";
import { withStorage } from "./features/with-storage.feature";
import { firstValueFrom } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";

export type StoreState = {
  store: Store;
};

const initialState: StoreState = {
  store: new Store(),
};

@Injectable({ providedIn: "root" })
export class StoreStore extends signalStore({ protectedState: false }, withState(initialState), withStorage("store", sessionStorage)) {
  storeId$ = toObservable(this.userStore.user.storeCode);
  storeId = "";

  constructor(
    private readonly userStore: UserStore,
    private readonly storeService: StoreService
  ) {
    super();
  }

  initialize(): void {
    this.storeId$.subscribe((storeIdRaw: string) => {
      const storeId = Number(storeIdRaw);
      if (!isNaN(storeId) && storeId !== 0) {
        this.storeId = storeId.toString();
        void this.getStore();
      }
    });
  }

  async getStore(): Promise<void> {
    if (this.store().id === "" || this.store().id === "0") {
      const idStore = Number(this.storeId);
      if (!isNaN(idStore)) {
        const store = await firstValueFrom(this.storeService.getStore(idStore.toString()));
        const storeInfo = new Store(
          store.id,
          store.name,
          store.streetAddress,
          store.city,
          store.state,
          store.comuna,
          store.regionName,
          store.countryCode,
          store.buName,
          Boolean(store.isActive),
          store.storeTimezone
        );
        patchState(this, {
          store: storeInfo,
        });
      }
    }
  }

  getStoreData(): Signal<Store> {
    return this.store;
  }
}
